const HP = {
   request: process.env.REACT_APP_API_PROTOCOL,
   host: process.env.REACT_APP_API_HOST,
};


export default HP;